import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { useModel } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const TableHeader = () => {
	const [{ supplierTotal, selectedSupplierBill }, { init }] = useModel(
		"supplierBill"
	);

	const history = useHistory();

	const onDetail = () => {
		init();
		history.push({ pathname: "/bill/supplier/detail", state: { id: "5-2-1" } });
	};


	return (
		<div style={{ margin: "0 0 8px", display: "flex" }}>
			<div style={{ width: "460px", paddingTop: "6px" }}>
				<YhAuth resCode={ResourceAuthEnum.ACC_S_VW}>
					<Button
						className="margin-left-8"
						type="primary"
						disabled={!!!selectedSupplierBill}
						onClick={onDetail}
					>账单详情</Button>
				</YhAuth>
			</div>
			<div className="detail-list-statistic" style={{ textAlign: "right" }}>
				<span className="margin-left-8 color-blue">
					已用授信额度合计：{supplierTotal.usedCreditLineTotal}
				</span>
				<span className="margin-left-16 color-blue">
					可用额度合计：{supplierTotal.availableCreditTotal}
				</span>
				<span className="margin-left-16 color-blue">
					剩余总金额合计：{supplierTotal.remainingAmountTotal}
				</span>
			</div>
		</div>
	);
};
export default function () {
	const [
		{
			searchParam,
			selectedSupplierBill,
			selectedSupplierRowKeysBill,
			supplierList,
			pageInfo,
		},
		{
			loadSupplierList,
			setSelectedSupplierBill,
			setSelectedSupplierRowKeysBill,
		},
	] = useModel("supplierBill");
	const [
		{ supplierTypeDict },
		{ getAccountTypeDict, getSupplierTypeDict },
	] = useModel("cmDict");
	useEffect(() => {
		getAccountTypeDict();
	}, []);
	const columns = [
		{
			title: "供应商名称",
			dataIndex: "supplierName",
			align: "left",
		},
		{
			title: "供应商编码",
			dataIndex: "supplierCode",
			render: (text) => <span>{text}</span>,
		},
		{
			title: "供应商类型",
			dataIndex: "supplierType",
			render: (text, record) => {
				return (
					<span>
						{supplierTypeDict.map((item) => {
							if (item.key == text) {
								return item.label;
							}
						})}
					</span>
				);
			},
		},
		{
			title: "授信额度",
			dataIndex: "creditLine",
		},
		{
			title: "已用授信额度",
			dataIndex: "usedCreditLine",
		},
		{
			title: "可用额度",
			dataIndex: "availableCredit",
		},
		{
			title: "剩余总金额",
			dataIndex: "remainingAmount",
		},
		{
			title: "欠款总额",
			dataIndex: "arrears",
		},
	];
	useEffect(() => {
		loadSupplierList({ showMsg: false, data: {} });
	}, []);
	const onPageChange = (page, pageSize) => {
		//分页切换
		// console.log(page,pagesize)
		const params = { ...searchParam };
		params.pageNum = page;
		params.pageSize = pageSize;
		loadSupplierList({ showMsg: false, data: params });
		//这里放切换列表的接口查询
	};

	return (
		<>
			<TableHeader />
			<Table
				columns={columns}
				dataSource={supplierList}
				bordered
				pagination={{
					// hideOnSinglePage: true,
					showSizeChanger: true,
					defaultCurrent: 1,
					defaultPageSize: 15,
					onChange: onPageChange,
					total: pageInfo.total,
					current: pageInfo.pageNum,
					pageSizeOptions: [15, 50, 100, 200, 500],
				}}
				rowSelection={{
					type: "radio",
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(
						//   `selectedRowKeys: ${selectedRowKeys}`,
						//   "selectedRows: ",
						//   selectedRows
						// );
						setSelectedSupplierBill(selectedRows[0]);
						setSelectedSupplierRowKeysBill(selectedRowKeys);
					},
					getCheckboxProps: (record) => ({
						disabled: record.name === "Disabled User",
						name: record.name,
					}),
					selectedRowKeys: selectedSupplierRowKeysBill,
				}}
				onRow={(record, index) => {
					return {
						onClick: (event) => {

							if (
								selectedSupplierBill &&
								selectedSupplierBill.key == record.key
							) {
								setSelectedSupplierBill(null);
								setSelectedSupplierRowKeysBill([]);
							} else {
								setSelectedSupplierBill(record);
								setSelectedSupplierRowKeysBill([record.key]);
							}
						}, // 点击行
					};
				}}
				scroll={{ x: "max-content" }}
			/>
		</>
	);
}
